module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/a61306cd04f80b60da119af9c0bd75ac.png";